import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { InternalService } from "./internal.service";
import { AuthService } from "./auth.service";
/**
 * Servicio para la gestión de compañías y páginas.
 * Proporciona métodos CRUD para compañías y páginas, y hereda manejo de errores.
 */
@Injectable()
export class CompanyService extends InternalService {
    /**
     * Constructor: inyecta dependencias necesarias.
     */
    constructor(http: HttpClient, router: Router, authService: AuthService) {
        super(http, router, authService);
    }

    /**
     * Realiza login de compañía.
     * @param data Credenciales de login.
     */
    login(data: any): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/login/`, data)
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Obtiene la información de la compañía actual.
     */
    me(): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.get(`${environment.apiUrl}/company/me/`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Obtiene todas las compañías.
     */
    allCompanies(): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.get(`${environment.apiUrl}/company/`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Obtiene una compañía por ID.
     * @param id ID de la compañía.
     */
    getCompany(id: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.get(`${environment.apiUrl}/company/${id}/`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Crea una nueva compañía.
     * @param data Datos de la compañía.
     */
    createCompany(data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.post(`${environment.apiUrl}/company/`, data, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Edita una compañía existente.
     * @param id ID de la compañía.
     * @param data Datos a actualizar.
     */
    editCompany(id: any, data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.put(`${environment.apiUrl}/company/${id}/`, data, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Elimina una compañía por ID.
     * @param id ID de la compañía.
     */
    deleteCompany(id: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.delete(`${environment.apiUrl}/company/${id}/`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Obtiene todas las páginas disponibles.
     */
    getPages(): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.get(`${environment.apiUrl}/pages/`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Crea una nueva página.
     * @param data Datos de la página.
     */
    createPage(data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.post(`${environment.apiUrl}/pages/`, data, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Edita una página existente.
     * @param id ID de la página.
     * @param data Datos a actualizar.
     */
    editPage(id: any, data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.put(`${environment.apiUrl}/pages/${id}/`, data, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /**
     * Elimina una página por ID.
     * @param id ID de la página.
     */
    deletePage(id: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));
        return this.http.delete(`${environment.apiUrl}/pages/${id}/`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
}